<template>
  <div id="warehouse">
    <div class="searchBox">
      <div class="myInput">
        <i class="el-icon-search"></i>
        <input type="text" v-model="form.searchText" @keydown.enter="getData()" :placeholder="$fanyi('请输入关键词搜索')" />
      </div>
      <button class="searchBtn" @click="getData()">
        {{ $fanyi('搜索') }}
      </button>
    </div>
    <!-- 表格 -->
    <div class="dataBody" v-loading="loanding">
      <div class="myTable">
        <div class="tableHead">
          <div class="no detailtd" title="NO">No</div>
          <div class="picture detailtd">
            {{ $fanyi('照片') }}
          </div>
          <div class="detail detailtd">
            {{ $fanyi('属性') }}
          </div>
          <div class="num detailtd">
            {{ $fanyi('购买数量') }}
          </div>
          <div class="price detailtd">{{ $fanyi('单价') }}(￥)</div>
          <div class="Product cost">{{ $fanyi('产品费用') }}(￥)</div>
          <div class="freight detailtd">{{ $fanyi('国内运费') }}(￥)</div>
          <div class="options detailtd">
            {{ $fanyi('OPTION') }}
          </div>
          <div class="buyNum detailtd" v-if="form.status == 'status_submit'">
            {{ $fanyi('可提货数量') }}
          </div>
          <div class="remark detailtd">
            {{ $fanyi('备注栏') }}
          </div>
        </div>
        <div class="tableboday" v-if="tableData.length != 0">
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item :name="index" v-for="(item, index) in tableData" :key="index">
              <template slot="title">
                <div class="ordersn">
                  {{ $fanyi('订单号') }} :
                  <span @click="toDetailPage(item)">{{ item.order_sn }}</span>
                </div>
              </template>
              <div class="goodsitem" v-for="(goodsItem, ind) in item.order_detail" :key="ind">
                <div class="no detailtd" title="NO">{{ ind + 1 }}</div>
                <div class="picture detailtd">
                  <el-popover placement="right" trigger="hover">
                    <img :src="goodsItem.pic" alt="" style="width: 288px; height: 300px" />

                    <el-image :src="goodsItem.pic" @click="
                      $fun.toCommodityDetails({
                        goods_id: goodsItem.goods_id,
                        shop_type: goodsItem.shop_type,
                        mi_id: goodsItem.mi_id || '',
                      })
                      " style="width: 60px; height: 60px" slot="reference">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                      <div slot="placeholder">
                        <i class="el-icon-loading"></i>
                      </div>
                    </el-image>
                  </el-popover>
                </div>
                <div class="detail detailtd">
                  <el-popover placement="bottom" trigger="hover">
                    <div class="goodsDetailAll">
                      <div class="goodsDetailAllOneBox" v-for="(detailItem, detailIndex) in goodsItem.detail"
                        :key="detailIndex" :title="detailItem.key + ':' + detailItem.value">
                        <h1 class="detailTitle">{{ detailItem.key }}</h1>
                        <p>
                          <span class="detailBody">{{ detailItem.value }}</span>
                        </p>
                      </div>
                    </div>

                    <div class="detailBox" slot="reference" style="cursor: pointer" @click="
                      $fun.toCommodityDetails({
                        goods_id: goodsItem.goods_id,
                        shop_type: goodsItem.shop_type,
                        mi_id: goodsItem.mi_id || '',
                      })
                      ">
                      <p style="width: 120px;" v-for="(item, index) in goodsItem.detail" :key="index"
                        :title="item.key + ':' + item.value">
                        <span class="detailKey">{{ item.key }}</span>
                        :
                        <span class="detailValue">{{ item.value }}</span>
                      </p>
                    </div>
                  </el-popover>
                </div>
                <div class="num detailtd">
                  {{ goodsItem.confirm_num }}
                </div>
                <div class="price detailtd">
                  {{ $fun.RMBNumSegmentation(goodsItem.confirm_price) }}
                </div>
                <div class="Product cost"> {{ $fun.RMBNumSegmentation(goodsItem.confirm_total) }}</div>


                <div class="freight detailtd">
                  {{ $fun.RMBNumSegmentation(goodsItem.confirm_freight) }}
                </div>
                <div class="options detailtd">
                  <el-popover placement="bottom" width="600" trigger="click">
                    <el-table :data="filteredData(goodsItem.option)" :header-cell-style="{
                      'text-align': 'center',
                      'font-size': '14px',
                      color: '#121212',
                      height: '40px !important',
                      background: '#F5F5F5 !important',
                      'font-weight': '400',
                    }" :cell-style="{
                      'text-align': 'center',
                      height: '50px !important',
                    }" size="mini">
                      <el-table-column property="tag" label="NO"></el-table-column>
                      <el-table-column property="name" :label="$fanyi('名称')">
                        <template slot-scope="scope">
                          <div style="color: #999999; overflow: hidden;text-overflow: ellipsis;
                                                                              white-space: nowrap;
                                                                            " :title="scope.row.name_translate">
                            {{ scope.row.name_translate }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column property="num" :label="$fanyi('数量')"></el-table-column>
                      <el-table-column property="price" :label="$fanyi('单价')" width="130px">
                        <template slot-scope="scope">
                          <div>
                            ₴{{
                              $fun.EURNumSegmentation(
                                $fun.ceil(scope.row.price * $store.state.exchangeRate)
                              )
                            }}

                            ({{
                              $fun.EURNumSegmentation(
                                $fun.ceil(scope.row.price)
                              )
                            }}￥)
                          </div>
                        </template></el-table-column>
                      <el-table-column property="price" width="150px" :label="$fanyi('总价')">
                        <template slot-scope="scope">
                          <div>
                            ₴{{
                              $fun.EURNumSegmentation(
                                $fun.ceil(
                                  scope.row.price * scope.row.num * $store.state.exchangeRate
                                )
                              )
                            }}

                            ({{
                              $fun.EURNumSegmentation(
                                $fun.ceil(scope.row.price * scope.row.num)
                              )
                            }}￥)
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- 附加服务 -->
                    <div class="showOption" slot="reference">
                      <div class="showOptionCon">
                        <p v-show="optionItem.num > 0" v-for="(optionItem, opionIndex) in goodsItem.option"
                          :key="opionIndex">
                          <span class="tagBox">{{ optionItem.tag }} </span>
                          {{ optionItem.name_translate }}
                          <span> * {{ optionItem.num }}</span>
                        </p>
                      </div>
                    </div>
                  </el-popover>
                </div>
                <div class="buyNum detailtd" v-if="form.status == 'status_submit'">
                  {{ goodsItem.totalWaitSubmitNum }}
                </div>
                <div class="remark detailtd">
                  <p>{{ goodsItem.client_remark }}</p>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="NoDaTa" v-if="tableData ? tableData.length == 0 : false">
          {{ $fanyi('暂无数据') }}
        </div>
      </div>
    </div>
    <div class="allpag">
      <span></span>
      <el-pagination @current-change="handleCurrentChange" :current-page="form.currentPage" :page-size="10"
        :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        status: 'status_submit',
        searchText: '',
        page: 1,
        pageSize: 10,
      },
      activeNames: [],
      loanding: false,
      tableData: [],

      total: 0,

    }
  },
  components: {},
  computed: {},
  created() {
    this.getData()
  },
  methods: {
    //点击订单号打开新标签进入详情页
    toDetailPage(item) {

      let baseUrl = window.location.origin
      window.open(baseUrl + `/orderDetails?type=purchase&order_sn=${item.order_sn}`, '_blank')
    },
    // 获取数据
    getData() {
      let datas = {
        status: this.form.status,
        keywords: this.form.searchText,
        page: this.form.page,
        pageSize: this.form.pageSize,
      }
      this.loanding = true
      this.$api.storageList(datas).then((res) => {
        this.loanding = false
        if (res.code != 0) return false
        if (res.data.length == 0) return false
        this.total = res.data.total
        this.form.currentPage = res.data.currentPage
        this.tableData = res.data.data
      })
    },
    filteredData(rawData) {
      // 使用 filter 方法筛选 num 不为 0 的对象
      return rawData.filter(item =>
        item.num !== 0 && item.num !== null && item.num !== undefined && item.num !== '');
    },
    handleChange() { },



    handleCurrentChange(val) {
      this.form.page = val
      this.getData()
    },

  },
}
</script>
<style>
.el-popover {

  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: 1px solid #dfdfdf;
  padding: 20px;
}
</style>
<style lang="scss" scoped>
.NoDaTa {
  font-size: 14px;
  color: #909399;
  text-align: center;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 80px;
  border-radius: 0 0 12px 12px;
  // border-left: solid 1px #ededed;
  // border-right: solid 1px #ededed;
  border-bottom: solid 1px #ededed;
}

#warehouse {
  @import '../../../../css/mixin';
  width: 1060px;

  background: #ffffff;
  border-radius: 20px;
  padding: 30px 20px;
  padding-bottom: 0px;

  .searchBox {
    display: flex;
    margin-bottom: 20px;

    .myInput {
      width: 400px;
      height: 40px;
      border-radius: 12px;
      position: relative;
      display: flex;
      align-items: center;
      // overflow: hidden;
      margin-right: 20px;

      >i {
        width: 20px;
        height: 24px;
        margin: 9px 11px 9px 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        color: #A2A2A2;
      }

      >input {
        border: 1px solid #e2e2e2;
        width: 100%;
        height: 100%;
        border-radius: 12px;
        font-size: 14px;
        padding-left: 40px;
        padding-right: 10px;
        transition: 0.3s;

        &:focus {
          border-color: #ff730b;
        }

        &::placeholder {
          color: #9a9a9a;
        }
      }
    }

    /deep/.el-date-editor {
      border-radius: 12px;
      width: 296px;
      height: 40px;
      margin-right: 20px;
      line-height: 32px !important;

      .el-input__inner {
        padding: 0px !important;
        border-radius: 12px;
      }

      .el-range-input {
        font-size: 14px;
        border-radius: 12px;
      }

      .el-range-separator {
        width: 50px;
        line-height: 23px;
      }

      .el-range__icon {
        line-height: 25px;
      }
    }

    .searchBtn {
      width: 80px;
      height: 40px;
      background: #d12a1d;
      border-radius: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;
      text-align: center;
      font-size: 14px;
    }

    .cancelledBtn {
      width: 150px;
      height: 40px;
      border-radius: 12px;
      border: 1px solid #d12a1d;

      text-align: center;
      cursor: pointer;
      margin-left: 54px;
      font-weight: 400;
      font-size: 16px;
      color: #d12a1d;
      line-height: 40px;
    }
  }

  .dataBody {


    .myTable {
      overflow-x: auto;

      // 设置滚动条
      &::-webkit-scrollbar {
        height: 4px;
      }

      // 设置表头样式
      .tableHead {
        width: 1200px;
        height: 70px;
        background: #f5f5f5;

        border-radius: 12px;
        border: 1px solid #dfdfdf;
        display: flex;
        align-items: center;
        padding: 0 20px;
        font-weight: 500;
        text-align: center;
        font-size: 14px;
        color: #121212;
        cursor: default;
        justify-content: space-between;

        div {
          line-height: 14px;
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 14px;
          color: #121212;
          justify-content: center;
        }

        .no {
          flex: 0 0 38px;
        }

        .picture {
          flex: 0 0 90px;
        }

        .detail {
          flex: 0 0 120px;
        }

        .num {
          flex: 0 0 100px;
        }

        .price {
          flex: 0 0 100px;
        }

        .freight {
          flex: 0 0 100px;
        }

        .Product {
          flex: 0 0 100px;
        }

        .options {
          flex: 0 0 160px;
        }

        .buyNum {
          flex: 0 0 130px;
        }

        .deliverableQuantity {
          flex: 0 0 130px;
        }

        .remark {
          flex: 0 0 160px;
        }
      }

      .tableboday {

        padding-top: 20px;
        padding-bottom: 20px;

        /deep/.el-collapse {
          width: 1200px !important;
          min-height: 50px;
          border: none !important;
          background: #ffffff;

          .el-collapse-item {
            width: 1200px !important;
            min-height: 50px;
            border-radius: 12px;
            background: #ffffff;
            border: 1px solid #dfdfdf;
            margin-bottom: 20px;

            >div {
              border-bottom: none !important;
              border-radius: 12px;
              background: #ffffff;
            }

            .el-collapse-item__header {
              height: 50px;
              display: flex;
              padding: 0 20px;
              align-items: center;
              background: #ffffff;

              border-radius: 12px;
              border: none !important;

              font-weight: 400;
              font-size: 14px;
              color: #121212;

              .ordersn {
                color: #121212;

                span {
                  font-size: 14px;
                  color: #d12a1d;
                  margin-left: 12px;

                  &:hover {
                    text-decoration: underline;
                    cursor: pointer;
                  }
                }
              }
            }

            .el-collapse-item__arrow {
              margin-left: 12px;
              color: #d12a1d;
              font-weight: 600;
            }

            .el-collapse-item__content {
              padding-bottom: 0px;
              border-radius: 12px;
              background: #fafafa;
            }
          }

          .el-collapse-item__wrap {
            background: #fafafa;
            border-radius: 12px;
          }
        }

        .goodsitem {
          display: flex;
          align-items: center;
          justify-content: space-between;

          min-height: 140px;
          border-bottom: 1px solid #dfdfdf;
          padding: 0 20px;

          &:last-child {
            border-bottom: none;
          }

          >div {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 14px;
            color: #121212;
            line-height: 14px;
            text-align: center;
          }

          .no {
            flex: 0 0 38px;
          }

          .picture {
            flex: 0 0 90px;
          }

          .detail {
            flex: 0 0 120px;

            .detailBox {
              height: 60px;
              overflow-y: auto;
              overflow-x: hidden; // 设置滚动条

              &::-webkit-scrollbar {
                width: 4px;
              }

              p {
                display: flex;
                align-items: center;
                text-align: left;
                margin-bottom: 5px;

                span {
                  font-weight: 400;
                  text-align: left;
                  font-size: 14px;
                  color: #121212;
                }
              }
            }
          }

          .num {
            flex: 0 0 100px;
          }

          .price {
            flex: 0 0 100px;
          }

          .freight {
            flex: 0 0 100px;
          }

          .Product {
            flex: 0 0 100px;
          }

          .options {
            flex: 0 0 160px;

            .showOption {
              width: 160px;
              padding: 13px;
              height: 100px;
              overflow-y: auto;
              background: #ffffff;
              border-radius: 10px;
              border: 1px solid #dfdfdf;

              p {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-bottom: 3px;

                span {
                  font-weight: 400;
                  font-size: 14px;
                  color: #121212;

                  &:last-child {
                    color: #d12a1d;
                  }
                }
              }
            }
          }

          .buyNum {
            flex: 0 0 130px;
          }

          .deliverableQuantity {
            flex: 0 0 130px;
          }

          .remark {
            flex: 0 0 160px;

            p {
              width: 160px;
              height: 100px;
              border-radius: 12px;
              border: 1px solid #dfdfdf;
              padding: 13px;
              overflow-y: auto;
              background-color: #fff;

              // 设置滚动条
              &::-webkit-scrollbar {
                width: 4px;
              }
            }
          }
        }
      }
    }
  }

  .allpag {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 30px 0px;
    box-sizing: border-box;

    .el-pagination {
      display: flex;
      align-items: center;
    }

    >a {
      display: inline-block;
      border: 1px solid #dcdfe6;
      height: 28px;
      // background-color: white;
      text-align: center;
      padding: 0 10px;
      font-size: 13px;
      line-height: 28px;
      border-radius: 0;
    }

    /deep/.btn-prev {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dfdfdf;
      padding: 0;
      margin-right: 15px;
      margin-left: 20px;

      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/.btn-next {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dfdfdf;
      padding: 0;
      margin-left: 15px;

      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/ .el-pagination__jump {
      .el-input {
        width: 50px;
        height: 30px;
        background: #ffffff;
        border-radius: 8px;
        margin-left: 5px;

        font-weight: 400;
        font-size: 14px;
        color: #000000;

        .el-input__inner {
          height: 30px;
          border-radius: 8px;
        }
      }
    }

    /* 分页被选中的页码样式 */
    /deep/ .el-pager li {
      margin: 0 5px;
      width: 30px;
      line-height: 30px;
      height: 30px;
      border-radius: 8px;
      // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

      &:hover {
        color: #d12a1d;
      }

      &.active {
        width: 30px;

        height: 30px;
        background: #d12a1d;
        line-height: 30px;
        color: #fff;
        border-radius: 8px;
      }
    }
  }
}

/deep/.el-table__header-wrapper {
  border-radius: 12px;


  .cell {
    line-height: 18px !important;
  }
}

.goodsDetailAll {
  max-height: 500px;
  overflow-y: auto;

  .goodsDetailAllOneBox {
    h1 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 5px;
    }

    p {
      max-width: 300px;
      margin-bottom: 8px;
    }
  }
}
</style>
